/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const JoinGroupResponse = zod.object({
  membership: zod.object({
    groupActorUuid: zod.uuid(),
    roles: zod.array(zod.string()),
    userActorUuid: zod.uuid(),
  }),
});

export type JoinGroupResponse = zod.input<typeof JoinGroupResponse>;
export type JoinGroupResponseOutput = zod.output<typeof JoinGroupResponse>;
